module.exports = __webpack_public_path__ + "static/img/payplat@2x.c4e3fc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/payplat@2x.png
// module id = wKfp
// module chunks = 1